<template>
  <div class="wrapper">
    <c-textarea
      v-model="localValue"
      label="Комментарий"
      :clearable="true"
      placeholder="Желаемый график работы, опыт работы и т.д."
      :required-mark="field.required"
      :max-length="maxLength"
      :invalid="!!error"
      :error="error"
    />
  </div>
</template>

<script>
import CTextarea from "@/components/controls/textarea";

export default {
  components: { CTextarea },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },
  computed: {
    maxLength() {
      if (this.field.maxLength) return this.field.maxLength;
      return false;
    },
  },

  watch: {
    localValue(v) {
      if (this.value === v) return;
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      this.localValue = value.value || "";

      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  /deep/ .c-input {
    padding-top: 6px;
  }
}
</style>
